export { DashboardModule } from './dashboard.module';
export { CanLoadDashboardGuard } from './guards/can-load.guard';
export { AlertsService } from './services/alerts.service';
export { PatientsStatisticService } from './services/patients-statistic.service';
